import { encryptData } from '../environment/data/privateHelpers.js';

const encryptUserID = async userID => encryptData(userID, [{
  userID: userID
}]);

export { encryptUserID };
